function setLocalStorageItem(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error("Error setting local storage item:", error);
  }
}

function getLocalStorageItem(key) {
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  } catch (error) {
    console.error("Error getting local storage item:", error);
    return null;
  }
}

class QuantityAction {
  constructor(element) {
    this.element = element;
    this.variantId = parseInt(element.dataset.variantId);
    this.minus = element.querySelector('button[name="minus"]');
    this.plus = element.querySelector('button[name="plus"]');
    this.input = element.querySelector('input');
    this.input.addEventListener('change', this.onChange.bind(this));
    this.initQuantityAction();
  }

  onChange() {
    const quoteItemsInstance = document.querySelector('quote-items');
    const quoteItems = getLocalStorageItem('user_quote');
    const targetItemIndex = quoteItems.findIndex(item => item.variant_id === this.variantId);
    const inputValue = parseInt(this.input.value);
    if(quoteItems?.length > 0) {
      if(inputValue === 0) {
        setLocalStorageItem('user_quote', quoteItems.filter(item => item.variant_id !== this.variantId));
        QuoteItems.reloadItems(quoteItemsInstance);
      } else {
        quoteItems[targetItemIndex].quantity = inputValue;
        setLocalStorageItem('user_quote', [...quoteItems]);
        QuoteItems.reloadItems(quoteItemsInstance);
      }
    }
  }

  initQuantityAction() {
    this.minus.addEventListener('click', () => {
      this.input.stepDown();
      this.input.dispatchEvent(new Event('change'));
    });
    this.plus.addEventListener('click', () => {
      this.input.stepUp();
      this.input.dispatchEvent(new Event('change'));
    });
  }
}

class RemoveAction {
  constructor(element) {
    this.element = element;
    this.button = element.querySelector('a.button');
    this.variantId = parseInt(this.button.dataset.variantId);
    this.button.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    event.preventDefault();
    const quoteItems = getLocalStorageItem('user_quote');
    const quoteItemsInstance = document.querySelector('quote-items');
    if(quoteItems?.length > 0) {
      setLocalStorageItem('user_quote', quoteItems.filter(item => item.variant_id !== this.variantId));
      QuoteItems.reloadItems(quoteItemsInstance);
    }
  }
}

class QuoteItems extends HTMLElement {
  constructor() {
    super();
    this.section = document.querySelector('.quote-block');
    this.table = this.querySelector('table');
    this.loadItems();
  }

  static reloadItems(instance) {
    instance.loadItems();
  }

  loadItems() {
    const quoteItems = getLocalStorageItem('user_quote');
    if(!quoteItems?.length) {
      this.section.classList.add('is-empty');
    } else {
      this.section.classList.remove('is-empty');
      const tableBody = this.table.querySelector('tbody');
      if(tableBody) {
        tableBody.innerHTML = "";
        quoteItems.forEach((item, index) => {
          tableBody.appendChild(this.createTableItem(item, index));
        });

        // Init quantity action
        const quantityActionElements = tableBody.querySelectorAll('.quantity');
        if(quantityActionElements?.length > 0) {
          Array.from(quantityActionElements).map(el => new QuantityAction(el));
        }

        // Init remove action
        const removeActionElements = tableBody.querySelectorAll('.cart-remove-button');
        if(removeActionElements?.length > 0) {
          Array.from(removeActionElements).map(el => new RemoveAction(el));
        }
      }
    }
  }

  createTableItem(item, index) {
    // Item row
    const row = document.createElement('tr');
    row.classList.add('cart-item');
    row.id = `QuoteItem-${index + 1}`;

    // Item row image
    const itemImageCell = document.createElement('td');
    itemImageCell.classList.add('cart-item__media');
    if(item.product_image) {
      const itemImageWrapper = document.createElement('a');
      itemImageWrapper.href = item.variant_url;
      itemImageWrapper.classList.add('cart-item__image-container');
      itemImageWrapper.classList.add('gradient');
      itemImageWrapper.classList.add('global-media-settings');
      const itemImage = document.createElement('img');
      itemImage.src = item.product_image;
      itemImage.classList.add('cart-item__image');
      itemImage.alt = item.product_title;
      itemImage.loading = "lazy";
      itemImage.width = "150";
      itemImage.height = "150";
      itemImageWrapper.appendChild(itemImage);
      itemImageCell.appendChild(itemImageWrapper);
    }
    row.appendChild(itemImageCell);

    // Item row details
    const itemDetailsCell = document.createElement('td');
    itemDetailsCell.classList.add('cart-item__details');

    // Item title
    const itemTitle = document.createElement('a');
    itemTitle.href = item.variant_url;
    itemTitle.classList.add('cart-item__name');
    itemTitle.classList.add('h4');
    itemTitle.style.fontWeight = 500;
    itemTitle.classList.add('break');
    itemTitle.innerHTML = item.product_title;
    itemDetailsCell.appendChild(itemTitle);

    // Show variant title if available and not "Default Title"
    if (item.variant_title && item.variant_title !== 'Default Title') {
      const variantTitle = document.createElement('span');
      variantTitle.classList.add('cart-item__variant');
      variantTitle.style.display = 'block';
      variantTitle.style.fontSize = '0.85em';
      variantTitle.style.opacity = '0.7';
      variantTitle.textContent = item.variant_title;
      itemDetailsCell.appendChild(variantTitle);
    }

    row.appendChild(itemDetailsCell);

    // Item row actions
    const itemActionsCell = document.createElement('td');
    itemActionsCell.classList.add('cart-item__quantity');
    const quantityWrapper = document.createElement('div');
    quantityWrapper.classList.add('cart-item__quantity-wrapper');

    /** Quantity Input */
    const quantityPopoverWrapper = document.createElement('div');
    quantityPopoverWrapper.classList.add('quantity-popover-container');
    const quantityInput = document.createElement('div');
    quantityInput.classList.add('quantity');
    quantityInput.classList.add('cart-quantity');
    quantityInput.setAttribute('data-variant-id', item.variant_id);

    /** Minus button */
    const minusButton = document.createElement('button');
    minusButton.classList.add('quantity__button');
    minusButton.setAttribute('name', "minus");
    minusButton.setAttribute('type', "button");
    const minusSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    minusSvg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
    minusSvg.setAttribute("aria-hidden", "true");
    minusSvg.setAttribute("focusable", "false");
    minusSvg.setAttribute("class", "icon icon-minus");
    minusSvg.setAttribute("fill", "none");
    minusSvg.setAttribute("viewBox", "0 0 10 2");
    const minusSvgPath = document.createElementNS("http://www.w3.org/2000/svg", "path");
    minusSvgPath.setAttribute("fill-rule", "evenodd");
    minusSvgPath.setAttribute("clip-rule", "evenodd");
    minusSvgPath.setAttribute("d", "M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z");
    minusSvgPath.setAttribute("fill", "currentColor");
    minusSvg.appendChild(minusSvgPath);
    minusButton.appendChild(minusSvg);
    quantityInput.appendChild(minusButton);

    /** Input */
    const input = document.createElement('input');
    input.classList.add('quantity__input');
    input.setAttribute('type', 'number');
    input.setAttribute('value', item.quantity);
    input.setAttribute('min', '0');
    input.setAttribute('step', '1');
    quantityInput.appendChild(input);

    /** Plus button */
    const plusButton = document.createElement('button');
    plusButton.classList.add('quantity__button');
    plusButton.setAttribute('name', "plus");
    plusButton.setAttribute('type', "button");
    const plusSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    plusSvg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    plusSvg.setAttribute('aria-hidden', 'true');
    plusSvg.setAttribute('focusable', 'false');
    plusSvg.setAttribute('class', 'icon icon-plus');
    plusSvg.setAttribute('fill', 'none');
    plusSvg.setAttribute('viewBox', '0 0 10 10');
    const plusSvgPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    plusSvgPath.setAttribute('fill-rule', 'evenodd');
    plusSvgPath.setAttribute('clip-rule', 'evenodd');
    plusSvgPath.setAttribute('d', 'M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z');
    plusSvgPath.setAttribute('fill', 'currentColor');
    plusSvg.appendChild(plusSvgPath);
    plusButton.appendChild(plusSvg);
    quantityInput.appendChild(plusButton);
    quantityPopoverWrapper.appendChild(quantityInput);
    quantityWrapper.appendChild(quantityPopoverWrapper);
    itemActionsCell.appendChild(quantityWrapper);
    row.appendChild(itemActionsCell);

    /** Remove button */
    const removeButtonWrapper = document.createElement('div');
    removeButtonWrapper.classList.add('cart-remove-button');
    const removeButton = document.createElement('a');
    removeButton.classList.add('button');
    removeButton.classList.add('button--tertiary');
    removeButton.setAttribute('data-variant-id', item.variant_id);

    /** Remove SVG */
    const removeSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    removeSvg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    removeSvg.setAttribute('viewBox', '0 0 16 16');
    removeSvg.setAttribute('aria-hidden', 'true');
    removeSvg.setAttribute('focusable', 'false');
    removeSvg.setAttribute('class', 'icon icon-remove');

    const removeSvgPath1 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    removeSvgPath1.setAttribute('d', 'M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z');
    removeSvgPath1.setAttribute('fill', 'currentColor');

    const removeSvgPath2 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    removeSvgPath2.setAttribute('d', 'M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z');
    removeSvgPath2.setAttribute('fill', 'currentColor');

    removeSvg.appendChild(removeSvgPath1);
    removeSvg.appendChild(removeSvgPath2);
    removeButton.appendChild(removeSvg);
    removeButtonWrapper.appendChild(removeButton);
    quantityWrapper.appendChild(removeButtonWrapper);

    return row;
  }
}

if(!customElements.get('quote-items')) {
  customElements.define('quote-items', QuoteItems)
}

class QuoteForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.formButton = this.form.querySelector('button');
    this.formButton.addEventListener('click', this.onSubmit);
  }

  onSubmit() {
    const inputsWrapper = this.form.querySelector('.form__products');
    if(inputsWrapper) {
      const quoteItems = getLocalStorageItem('user_quote');
      if(quoteItems?.length > 0) {
        if(inputsWrapper.innerHTML) {
          inputsWrapper.innerHTML = "";
        }
        quoteItems.forEach((item, index) => {
          const input = document.createElement('input');
          input.setAttribute('type', 'hidden');
          const variantLabel = item.variant_title && item.variant_title !== 'Default Title' ? ` (${item.variant_title})` : '';
          input.setAttribute('name', `contact[${item.product_title.replaceAll('&quot;', "").replaceAll(' ', '_')}${variantLabel.replaceAll(' ', '_')}]`);
          input.setAttribute('value', `Product Title: ${item.product_title.replaceAll('&quot;', "")}${variantLabel}, Product SKU: ${ item.sku }, Quantity: ${item.quantity}`);
          inputsWrapper.appendChild(input);
        });
      }
    }

    const requiredFields = this.form.querySelectorAll('input[required]');
    let sendForm = true;
    if(requiredFields) {
      requiredFields.forEach(input => {
        if(!input.value) {
          sendForm = false;
        }
      });
    }

    const formMessage = this.form.querySelector('.form__message');
    if(sendForm) {
      formMessage.classList.add('hidden');
      this.form.submit();
    } else {
      formMessage.classList.remove('hidden');
    }

  }
}

if(!customElements.get('quote-form')) {
  customElements.define('quote-form', QuoteForm)
}
